<template>
  <div class="memed-modern">
    <NavBar />

    <AuthBySessionExpired />

    <div class="memed-container">
      <div class="memed-header">
        <div class="header-content">
          <h1 class="page-title">
            <i class="fas fa-prescription-bottle-alt title-icon"></i>
            Receita Digital
          </h1>

          <div class="page-subtitle">
            Prescreva de forma digital, rápida e segura.
          </div>
        </div>
      </div>

      <div class="tab-content-modern">
        <div class="form-card">
          <div class="card-content">
            <div class="form-vertical">
              <div v-if="errors.length == 0" class="container-modern">
                <div class="col-md-12">
                  <label class="filter-label">Residentes:</label>
                  <v-select
                    v-model="resident_id"
                    :items="residents"
                    item-text="name"
                    item-value="id"
                    :disabled="memedLoading"
                    class="filter-select"
                    clearable
                    :loading="loading"
                    placeholder="Selecione o residente"
                    solo
                    hide-details="auto"
                  ></v-select>
                </div>
              </div>

              <div class="memed-content">
                <div v-if="errors.length == 0" class="memed-actions">
                  <v-btn
                    class="btn-sign-cloud"
                    @click="showMemed"
                    :disabled="memedLoading || !selectedResident"
                    :loading="memedLoading"
                    large
                    aria-label="Abrir receita digital"
                  >
                    <i class="fas fa-prescription-bottle-alt btn-icon"></i>
                    <span v-if="!memedLoading">Abrir Receita Digital</span>
                    <span v-else>Carregando...</span>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="errors.length > 0" class="memed-error-box">
        <div class="memed-error-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </div>

        <div class="memed-error-content">
          <h3 class="memed-error-title">Cadastro de Prescritor necessário</h3>

          <p class="memed-error-text">
            Para utilizar a prescrição digital, é preciso se cadastrar como
            prescritor na Memed.
          </p>

          <p class="memed-error-text">
            Acesse o menu <b>Usuários</b>, vá até a <b>Aba Memed</b> e realize
            seu cadastro.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global MdHub, MdSinapsePrescricao */

import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import toast from "../lib/ToastNotification";

import api from "../services/api";

import moment from "moment";

export default {
  name: "DigitalRecipe",

  components: {
    NavBar,
    AuthBySessionExpired,
  },

  data() {
    return {
      errors: [],

      residents: [],

      tokenUser: null,

      resident_id: null,

      loading: false,

      memedLoaded: false,

      memedVisible: false,

      memedLoading: false,

      memedReady: false,

      memedError: false,

      memedTimeout: null,

      memedShouldOpen: false,
    };
  },

  computed: {
    selectedResident() {
      return this.residents.find((resident) => resident.id === this.resident_id)
        ? this.residents.find((resident) => resident.id === this.resident_id)
        : null;
    },
  },

  async mounted() {
    await this.getResidents();

    await this.getTokenByUserLoggedIn();

    this.checkMemedReadyOrLoad();
  },

  beforeDestroy() {
    window.__memedModuleInitListener = false;
  },

  methods: {
    async getResidents() {
      try {
        this.loading = true;

        let params = { status_resident: "ATIVO" };

        const response = await api.get("/rest-home/residents", { params });

        const { error, residents } = response.data;

        if (!error) {
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async getTokenByUserLoggedIn() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/memed/prescritor/user-token"
        );

        const { error, errors, tokenUser } = response.data;

        if (!error) {
          this.errors = [];

          this.tokenUser = tokenUser;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async showMemed() {
      if (!this.selectedResident) {
        toast("Selecione um residente!", "error");
        return;
      }

      this.memedError = false;
      this.memedLoading = true;
      this.memedShouldOpen = true;

      if (
        typeof MdHub != "undefined" &&
        MdHub.module &&
        typeof MdHub.module.hide == "function"
      ) {
        MdHub.module.hide("plataforma.prescricao");
      }

      if (this.memedReady) {
        await this.openMemed();
      }
    },

    async openMemed() {
      try {
        let { selectedResident } = this;

        if (selectedResident) {
          let { id, name, phone, date_of_birth, cpf } = selectedResident;

          await MdHub.command.send("plataforma.prescricao", "setPaciente", {
            idExterno: id,
            nome: name,
            telefone: phone ? phone : "",
            data_nascimento: date_of_birth
              ? moment(date_of_birth).format("DD/MM/YYYY")
              : "",
            cpf: cpf ? cpf : "",
          });
        }
      } catch (error) {
        toast("Erro ao enviar paciente para o Memed!", "error");
        this.memedLoading = false;

        return;
      }

      if (
        typeof MdHub != "undefined" &&
        MdHub.module &&
        typeof MdHub.module.show == "function"
      ) {
        MdHub.module.show("plataforma.prescricao");
        this.memedShouldOpen = false;

        this.memedLoading = false;
      }
    },

    checkMemedReadyOrLoad() {
      if (document.querySelector('script[data-memed="true"]')) {
        if (
          typeof MdSinapsePrescricao != "undefined" &&
          MdSinapsePrescricao.event &&
          typeof MdHub != "undefined" &&
          MdHub.module &&
          typeof MdHub.module.show == "function"
        ) {
          this.memedReady = true;

          this.memedLoading = false;

          this.memedError = false;
        } else {
          this.listenModuleInit();
        }
      } else {
        this.loadMemedScript();
      }
    },

    loadMemedScript() {
      if (document.querySelector('script[data-memed="true"]')) {
        this.listenModuleInit();

        return;
      }

      this.memedLoading = true;
      this.memedLoaded = false;
      this.memedError = false;

      const script = document.createElement("script");

      // URL Teste
      script.src = "https://partners.memed.com.br/integration.js";

      script.dataset.token = this.tokenUser;

      script.setAttribute("data-memed", "true");

      script.onload = this.onMemedScriptLoaded;

      script.onerror = () => {
        this.memedLoading = false;

        this.memedError = true;
      };

      document.body.appendChild(script);

      if (this.memedTimeout) {
        clearTimeout(this.memedTimeout);
      }

      this.memedTimeout = setTimeout(() => {
        if (!this.memedLoaded) {
          this.memedLoading = false;

          this.memedError = true;
        }
      }, 20000);
    },

    onMemedScriptLoaded() {
      this.memedLoaded = true;

      this.memedLoading = false;

      this.listenModuleInit();
    },

    listenModuleInit() {
      if (window.__memedModuleInitListener) {
        return;
      }

      window.__memedModuleInitListener = true;

      const checkAndAddListener = () => {
        if (
          typeof MdSinapsePrescricao != "undefined" &&
          MdSinapsePrescricao.event
        ) {
          MdSinapsePrescricao.event.add("core:moduleInit", async (module) => {
            if (module.name == "plataforma.prescricao") {
              this.memedReady = true;

              this.memedLoading = false;

              this.memedError = false;

              if (this.memedShouldOpen) {
                await this.openMemed();
              }
            }
          });
        } else {
          setTimeout(checkAndAddListener, 500);
        }
      };

      checkAndAddListener();
    },
  },
};
</script>

<style scoped>
.tab-content-modern {
  margin-bottom: 32px;
}

.form-vertical {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  margin-bottom: 24px;
}

.card-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.card-title i {
  color: #0f65b0;
}

.card-content {
  padding: 24px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.container-modern {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(30, 41, 59, 0.06);
  padding: 5px 24px 1px 15px;
  margin: 25px 25px;
  display: flex;
  gap: 25px;
}

.filter-label {
  font-size: 16px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 6px;
}

.filter-select >>> .vs__dropdown-toggle:focus,
.filter-select >>> .vs__dropdown-toggle:hover {
  border-color: #0f65b0;
}

.memed-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.memed-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.memed-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  text-align: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 8px 0 0 0;
  font-size: 16px;
}

.memed-content {
  margin-bottom: 32px;
}

.memed-actions {
  text-align: center;
  margin-bottom: 24px;
}

/* Botão no estilo Cloud */
.btn-sign-cloud {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 16px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 16px !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
  min-width: 280px !important;
  height: 56px !important;
}

.btn-sign-cloud:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(78, 145, 48, 0.4) !important;
}

.btn-sign-cloud:disabled {
  opacity: 0.8 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.btn-icon {
  margin-right: 8px;
  font-size: 18px;
}

.memed-error-box {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 16px;
  padding: 24px 32px;
  margin: 32px 0;
  box-shadow: 0 2px 12px rgba(220, 38, 38, 0.06);
}

.memed-error-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fee2e2;
  border-radius: 50%;
  width: 56px;
  height: 56px;
}

.memed-error-icon i {
  color: #dc2626;
  font-size: 32px;
}

.memed-error-content {
  flex: 1;
}

.memed-error-title {
  color: #dc2626;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.memed-error-text {
  color: #991b1b;
  font-size: 15px;
  margin: 0 0 6px 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .memed-container {
    padding: 0 16px;
  }
  .memed-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }
  .header-content {
    padding: 0 16px;
  }
  .page-title {
    font-size: 24px;
    flex-direction: column;
    gap: 8px;
  }
  .page-subtitle {
    font-size: 14px;
  }
  .btn-sign-cloud {
    min-width: 100% !important;
    font-size: 14px !important;
    padding: 14px 24px !important;
    height: 50px !important;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }
  .title-icon {
    font-size: 20px;
  }
}
</style>